export const RenderEasy = {
    paddleColor: 'white',
    ballColor: 'white',
    canvasBackground: 'black',
    lineColor:'white',
    divisionLineWidth: 5,
    fieldWidth:400,
    fieldHeight:200,
    paddleWidth: 10,
    paddleHeight: 40,
    paddleSpeed: 10,
    ballDiameter: 10,
    ballSpeed: 10,
    gateWidth: 80,
    gateDepth: 20,
    paddleOffset: 10
};

export const RenderHard = {
    paddleColor: 'white',
    ballColor: 'white',
    canvasBackground: 'black',
    lineColor:'white',
    divisionLineWidth: 5,
    fieldWidth:400,
    fieldHeight:200,
    paddleWidth: 10,
    paddleHeight: 40,
    paddleSpeed: 10,
    ballDiameter: 10,
    ballSpeed: 10,
    gateWidth: 200,
    gateDepth: 20,
    paddleOffset: 10,
    blockHeight: 10,
    blockWidth: 60,
    middleBlocks: 4,
    fieldBlocks: 2
};